// removed by extract-text-webpack-plugin
module.exports = {"box":"_2RvOKB3n9p9t37wMlH2oIS","iconBtn":"_2xqVzt78jo8c1wil8rUQwg","list":"MFusvU2iOYi4V10EcNaf3"};


//////////////////
// WEBPACK FOOTER
// ./src/App/pages/CreateExperience/ExperiencesList/style.module.css
// module id = 461
// module chunks = 39